import type { App } from "vue";

// import {
//   Modal,
//   Table,
//   Menu,
//   Input,
//   Form,
//   Card,
//   Checkbox,
//   Radio,
//   Button,
//   Divider,
//   Select,
//   TreeSelect,
//   PageHeader,
//   Descriptions,
//   Tabs,
//   Row,
//   Col,
//   message,
//   Skeleton,
//   Popconfirm,
//   Drawer,
//   InputNumber,
//   Switch,
//   Cascader,
//   ConfigProvider,
//   Tag,
//   Tree,
//   Upload,
//   Pagination,
//   Timeline,
//   Dropdown,
//   Spin,
//   Alert,
//   Popover,
//   Tooltip,
//   Empty,
//   Steps,
//   Result,
//   Collapse,
//   Badge,
//   Space,
//   Image,
//   AutoComplete,
//   Statistic,
//   Progress,
//   Carousel,
//   Anchor
// } from "ant-design-vue";
import Antd from "ant-design-vue";
import DatePicker from "ant-design-vue/es/date-picker/moment";
import TimePicker from "ant-design-vue/es/time-picker/moment";
import Calendar from "ant-design-vue/es/calendar/moment";
// import "ant-design-vue/dist/antd.less";
import "ant-design-vue/dist/reset.css";
export function setupAntDesign(app: App<Element>) {
  // app
  //   .use(Image)
  //   .use(Space)
  //   .use(Form)
  //   .use(Input)
  //   .use(InputNumber)
  //   .use(Modal)
  //   .use(Table)
  //   .use(Menu)
  //   .use(Card)
  //   .use(Checkbox)
  //   .use(Radio)
  //   .use(Button)
  //   .use(Divider)
  //   .use(Select)
  //   .use(TreeSelect)
  //   .use(PageHeader)
  //   .use(Descriptions)
  //   .use(Tabs)
  //   .use(Row)
  //   .use(Col)
  //   .use(Skeleton)
  //   .use(Popconfirm)
  //   .use(Drawer)
  //   .use(Switch)
  //   .use(Cascader)
  //   .use(ConfigProvider)
  //   .use(Tag)
  //   .use(Tree)
  //   .use(Pagination)
  //   .use(Upload)
  //   .use(Dropdown)
  //   .use(Timeline)
  //   .use(Spin)
  //   .use(Alert)
  //   .use(Popover)
  //   .use(Empty)
  //   .use(Tooltip)
  //   .use(Steps)
  //   .use(Collapse)
  //   .use(Badge)
  //   .use(Result)
  //   .use(AutoComplete)
  //   .use(DatePicker)
  //   .use(TimePicker)
  //   .use(Calendar)
  //   .use(Progress)
  //   .use(Statistic)
  //   .use(Carousel)
  //   .use(Anchor);

  // message.config({
  //   maxCount: 1,
  // });
  app.use(Antd).use(DatePicker).use(TimePicker).use(Calendar);
}
